import React from 'react';
import { Field } from '@h2/types';

interface RadioInputProps {
  field: Field;
  value: string;
  onChange: (value: string) => void;
  error?: string;
}

export const RadioInput: React.FC<RadioInputProps> = ({ field, value, onChange, error }) => {
  if (!field.options) {
    return <div className="text-red-500">Radio field requires options</div>;
  }

  return (
    <div className="space-y-3">
      {field.options.map((option) => (
        <div key={String(option.value)} className="flex items-start space-x-3">
          <input
            type="radio"
            id={`${field.id}-${option.value}`}
            name={field.id}
            value={String(option.value)}
            checked={value === String(option.value)}
            onChange={(e) => onChange(e.target.value)}
            className="mt-1 h-4 w-4 text-primary focus:ring-primary border-gray-300"
          />
          <div className="flex-1">
            <label 
              htmlFor={`${field.id}-${option.value}`}
              className="block text-sm font-medium text-gray-900 dark:text-gray-100 cursor-pointer"
            >
              {option.label}
            </label>
            {option.description && (
              <p className="text-xs text-gray-500 dark:text-gray-400 mt-1">
                {option.description}
              </p>
            )}
          </div>
        </div>
      ))}
      {error && (
        <p className="text-xs text-red-500 mt-1">
          {error}
        </p>
      )}
    </div>
  );
};
